import { useState, useRef } from 'react';
import styles from './add-text.modules.sass';

export default function AddTExt() {
  const [text, setText] = useState('');
  const refInput = useRef();

  const onTextChange = (e) => {
    if (refInput.current.value.length < 18) {
      setText(refInput.current.value);
      // console.log(refInput.current.value);
    } else alert('Not more 18 symbols please');
  };

  return (
    <div className="wrapper">
      <input type={text} ref={refInput} onChange={onTextChange} value={text} />
    </div>
  );
}
